import { retailerAppFooterHeight } from '@/views/RetailerAppFooter';
import { RefObject, useLayoutEffect, useState } from 'react';

/**
 * The height from where `ref` starts down to the fixed footer, re-measured when the window or the
 * content above it changes size. Put `ref` on an empty element just above the scrolling box.
 */
export const useHeightToViewportBottom = (ref: RefObject<HTMLElement>) => {
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      if (!ref.current) {
        return;
      }
      // From the top of the page, so a scrolled page measures the same as an unscrolled one.
      const top = ref.current.getBoundingClientRect().top + window.scrollY;
      setHeight(window.innerHeight - top - retailerAppFooterHeight);
    };

    measure();
    const observer = new ResizeObserver(measure);
    if (ref.current?.parentElement) {
      observer.observe(ref.current.parentElement);
    }
    window.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [ref]);

  return height;
};
